import React, { useState } from 'react';
import CustomTextField, { CustomTextFieldProps } from './customTextField';
import { HideTextInputAdornment } from './inputAdornments/hideTextInputAdornment';
import { Box } from '@mui/material';

export default function PasswordTextField({
  label,
  id = 'password',
  name = 'password',
  typographyVariantSize = 'f16',
  labelTypographyVariantSize = 'f12',
  wrapperSxProps,
  type,
  ...props
}: CustomTextFieldProps) {
  const [isPasswordVisible, setIsPasswordVisible] = useState<boolean>(false);

  const toggleIsPasswordVisible = () =>
    setIsPasswordVisible((prevState) => !prevState);

  return (
    <CustomTextField
      label={label}
      id={id}
      name={name}
      typographyVariantSize={typographyVariantSize}
      labelTypographyVariantSize={labelTypographyVariantSize}
      placeholder={props.placeholder}
      wrapperSxProps={{
        width: 1,
        ...wrapperSxProps,
      }}
      type={isPasswordVisible ? 'text' : 'password'}
      InputProps={{
        endAdornment: (
          <Box sx={{ mr: -2 }}>
            <HideTextInputAdornment
              position="end"
              onClick={toggleIsPasswordVisible}
              isVisible={isPasswordVisible}
            />
          </Box>
        ),
      }}
      {...props}
    ></CustomTextField>
  );
}
